var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlarm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_359_2483",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#7B7B7B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_359_2483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 21.5C10.8205 21.5 9.71538 21.2769 8.68461 20.8307C7.65385 20.3846 6.75513 19.7782 5.98846 19.0115C5.22181 18.2448 4.61541 17.3461 4.16926 16.3154C3.7231 15.2846 3.50001 14.1795 3.50001 13C3.50001 11.8205 3.7231 10.7154 4.16926 9.68461C4.61541 8.65385 5.22181 7.75513 5.98846 6.98846C6.75513 6.22181 7.65385 5.61541 8.68461 5.16926C9.71538 4.7231 10.8205 4.50001 12 4.50001C13.1795 4.50001 14.2846 4.7231 15.3154 5.16926C16.3461 5.61541 17.2448 6.22181 18.0115 6.98846C18.7782 7.75513 19.3846 8.65385 19.8307 9.68461C20.2769 10.7154 20.5 11.8205 20.5 13C20.5 14.1795 20.2769 15.2846 19.8307 16.3154C19.3846 17.3461 18.7782 18.2448 18.0115 19.0115C17.2448 19.7782 16.3461 20.3846 15.3154 20.8307C14.2846 21.2769 13.1795 21.5 12 21.5ZM14.9731 17.0269L16.0269 15.9731L12.75 12.6961V7.99999H11.25V13.3038L14.9731 17.0269ZM5.75384 2.88849L6.80766 3.94231L2.94231 7.80766L1.88849 6.75384L5.75384 2.88849ZM18.2461 2.88849L22.1115 6.75384L21.0577 7.80766L17.1923 3.94231L18.2461 2.88849ZM12 20C13.9436 20 15.5961 19.3192 16.9577 17.9577C18.3192 16.5961 19 14.9436 19 13C19 11.0564 18.3192 9.40384 16.9577 8.04229C15.5961 6.68076 13.9436 5.99999 12 5.99999C10.0564 5.99999 8.40384 6.68076 7.04229 8.04229C5.68075 9.40384 4.99999 11.0564 4.99999 13C4.99999 14.9436 5.68075 16.5961 7.04229 17.9577C8.40384 19.3192 10.0564 20 12 20Z",
    fill: "#3D3D3D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.6d362964597908ce5a257c7566185a98.svg";
export { ForwardRef as ReactComponent };